<div
	[style.backgroundImage]="
		'url(' + (controller.headerImageUrl$ | ngrxPush) + ')'
	"
	class="
		flex
		p-6
		space-x-3
		p-background-color-primary
		bg-cover bg-blend-luminosity bg-center
		p-color-primary-text
	"
>
	<div
		[style.backgroundImage]="'url(' + (controller.pictureUrl$ | async) + ')'"
		class="
			flex-none
			relative
			p-rounded
			w-16
			h-16
			bg-cover bg-center
			group
			bg-black bg-opacity-30
		"
	>
		<div
			[class.flex]="controller.isUploadingAvatar$ | async"
			[class.hidden]="!(controller.isUploadingAvatar$ | async)"
			class="
				p-rounded
				group-hover:flex
				items-center
				justify-center
				absolute
				bg-white bg-opacity-70
				inset-0
			"
		>
			<p-progressSpinner
				*ngIf="controller.isUploadingAvatar$ | async; else upload"
				styleClass="w-14 h-14"
			></p-progressSpinner>
			<ng-template #upload>
				<input
					#file
					(change)="onAvatarChange($event)"
					class="hidden"
					accept="image/*"
					type="file"
				/>
				<p-button (onClick)="file.click()" icon="fas fa-upload"></p-button>
			</ng-template>
		</div>
	</div>
	<div class="flex-auto flex flex-col items-start justify-between space-y-1">
		<div class="text-3xl font-semibold p-rounded bg-black bg-opacity-30 px-3">
			{{ controller.title$ | async }}
		</div>
		<div class="text-lg p-rounded bg-black bg-opacity-30 px-3">
			{{ controller.remark$ | async }}
		</div>
	</div>
	<ng-content select="[actions]"></ng-content>
</div>
<div [class]="styleClass" class="flex-auto relative h-full">
	<ng-content></ng-content>
</div>
